import { render, staticRenderFns } from "./CurationWriteDefaultLayout.vue?vue&type=template&id=0132e93c&scoped=true"
import script from "./CurationWriteDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CurationWriteDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132e93c",
  null
  
)

export default component.exports